import { FC } from "react";

import { Box, Paper, type PaperProps } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardDivider } from "@/dashboard-design-system/Divider";
import { Add } from "@/icons/outlined";

export interface FundSelectPaperProps extends PaperProps {
  onCreateNewFund?: () => void;
}

export const FundSelectPaper: FC<FundSelectPaperProps> = ({ children, onCreateNewFund, ...rest }) => {
  const { t } = useTranslate();

  return (
    <Paper
      {...rest}
      sx={(theme) => ({
        boxShadow: theme.boxShadow.base.mid,
        borderRadius: theme.radius(2),
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        maxHeight: theme.spacing(50),
      })}
    >
      <Box sx={{ overflowY: "auto", flexGrow: 1 }}>{children}</Box>
      <DashboardDivider />
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          p: 0.5,
          position: "sticky",
          bottom: 0,
          zIndex: 1,
        })}
      >
        <DashboardButton
          variant="text"
          vibe="brand"
          startIcon={<Add />}
          fullWidth
          onMouseDown={(e) => {
            e.stopPropagation();
            onCreateNewFund?.();
          }}
          sx={{ justifyContent: "flex-start" }}
        >
          {t("dashboard", "funds.createNewFund")}
        </DashboardButton>
      </Box>
    </Paper>
  );
};
